import { render, staticRenderFns } from "./Scene9.vue?vue&type=template&id=133147c9&scoped=true"
import script from "./Scene9.vue?vue&type=script&lang=js"
export * from "./Scene9.vue?vue&type=script&lang=js"
import style0 from "./Scene9.vue?vue&type=style&index=0&id=133147c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133147c9",
  null
  
)

export default component.exports